import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomDialogBox from "src/components/CustomDialog";
import { LimitsSliceAction } from "src/slices/networkState";
import { RootState } from "src/store";
import { inconvenience } from "src/constants/cover-images";
import {
  DisplayFlexColumn,
  HeightandWidth,
  PopinsForteenTextBtn,
  PopinsSixteenText,
} from "src/components/Style";

export default function Index() {
  const dispatch = useDispatch();
  const { openMachineLimitDialog } = useSelector(
    (state: RootState) => state.networkState
  );

  // close dialog
  const handleClose = () => {
    dispatch(LimitsSliceAction.openMachineLimitDialog(false));
  };

  return (
    <>
      <CustomDialogBox
        open={openMachineLimitDialog}
        setOpen={handleClose}
        closeIconId="close-subscribe-news-dialog-btn"
        width={{ xs: "90vw", sm: "auto", md: "auto", lg: "630px", xl: "auto" }}
        height={{ xs: "auto", sm: "auto", md: "auto", lg: "auto", xl: "auto" }}
        childrens={
          <HeightandWidth
            sx={{
              padding: "20px",
              margin: "auto",
            }}
          >
            <DisplayFlexColumn>
              <PopinsSixteenText align="center">Disclaimer!</PopinsSixteenText>
              <DisplayFlexColumn>
                <img
                  style={{ width: "50%", height: "50%" }}
                  src={inconvenience}
                  alt="image"
                />
              </DisplayFlexColumn>
              <PopinsSixteenText align="center">
                Please try again after sometime,
              </PopinsSixteenText>
              <PopinsSixteenText align="center">
                We are facing issues with requested Cloud Provider
              </PopinsSixteenText>
              <PopinsForteenTextBtn
                id="publish-yes"
                sx={{
                  mt: 2,
                }}
                autoFocus
                variant="contained"
                onClick={handleClose}
                type="submit"
                size="medium"
                style={{
                  borderRadius: "4px",
                  backgroundColor: "#3087EC",
                  color: "white",
                  width: "100px",
                }}
              >
                Okay
              </PopinsForteenTextBtn>
            </DisplayFlexColumn>
          </HeightandWidth>
        }
      />
    </>
  );
}
